


document.addEventListener('DOMContentLoaded', function () {


	// HERO SLIDER
	const swiperHero = new Swiper('.js_swiper_hero', {
		slidesPerView: 1,
		spaceBetween: 0,
		resistanceRatio: 0,
		// freeMode: false,
		// shortSwipes: false,
		// longSwipes: false,

		allowTouchMove: false,



		loop: true,
		effect: 'fade',
		// fadeEffect: {
		// 	crossFade: true
		// },



		speed: 1000,
		autoplay: {
			delay: 5000,
			// pauseOnMouseEnter: true,
		},
		pagination: {
			el: '.hero__pagination',
			clickable: true,
		},
		navigation: {
			prevEl: '.slider__arrow_prev',
			nextEl: '.slider__arrow_next',
		},

		preventInteractionOnTransition: true,

		on: {
			slideNextTransitionStart: function (swiper) {
				heroSlidePic(swiper.slides.length, swiper.realIndex, 'next');
			},
			slidePrevTransitionStart: function (swiper) {
				heroSlidePic(swiper.slides.length, swiper.realIndex, 'prev');
			},

			// slideChangeTransitionEnd: function (swiper) {
			// 	heroSlidePic(swiper.slides.length, swiper.realIndex, 'next');
			// },


		},
	});


	// touch/swipe stuff
	document.querySelectorAll('.js_swiper_hero').forEach(heroSlider => {
		let touchstartX = 0;
		let touchendX = 0;
		let clickstartX = 0;
		let clickX = 0;


		heroSlider.addEventListener('touchstart', (e) => {
			touchstartX = e.changedTouches[0].screenX;
		}, { passive: supportsPassive ? true : false });
		heroSlider.addEventListener('touchend', (e) => {
			touchendX = e.changedTouches[0].screenX;
			if (touchendX > touchstartX) {
				swiperHero.slidePrev();
			}
			if (touchendX < touchstartX) {
				swiperHero.slideNext();
			}
		});


		let isActive = false;
		heroSlider.addEventListener('mousedown', (e) => {
			isActive = true;
			clickstartX = e.pageX;
		});
		heroSlider.addEventListener('mousemove', (e) => {
			if (isActive) {
				clickX = e.pageX;
				if (clickX - clickstartX < -150) {
					swiperHero.slideNext();
					isActive = false;
				}
				if (clickX - clickstartX > 150) {
					swiperHero.slidePrev();
					isActive = false;
				}
			}
		});
		heroSlider.addEventListener('mouseup', (e) => {
			isActive = false;
		})
	});




	function heroSlidePic(length, realIndex, direction) {
		const heroPics = document.querySelectorAll('.hero__pics .hero__pic');
		heroPics.forEach(item => {
			item.classList.remove('m-active', 'm-active-reverse');
		});
		// go right
		if (direction == 'next') {
			let nextIndex = realIndex === 0 ? length - 1 : realIndex - 1;
			heroPics[realIndex].classList.add('m-active');
			heroPics[nextIndex].classList.add('m-subactive');
		}
		// go left
		else {
			let prevIndex = realIndex === length - 1 ? 0 : realIndex + 1;
			heroPics[realIndex].classList.add('m-active-reverse');
			heroPics[prevIndex].classList.add('m-subactive-reverse');
		}
		setTimeout(() => {
			heroPics.forEach(item => {
				item.classList.remove('m-subactive', 'm-subactive-reverse');
			});
		}, 1000);
	}

	// ===============

	// PROJECTS SLIDER

	if (window.matchMedia(`(max-width: ${media_md - 0.2}px)`).matches) {
		const swiperMprojects = new Swiper('.js_swiper_mprojects', {
			slidesPerView: 'auto',
			spaceBetween: 0,
			resistanceRatio: 0,
			watchSlidesProgress: true,
			loop: true,

			// speed: 700,
			// autoplay: {
			// 	delay: 7000,
			// },

		});
	}

	// ===============

	// CHOISE OF THE WEEK SLIDER
	const swiperWeek = new Swiper('.js_swiper_week', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		resistanceRatio: 0,
		loop: true,
		freeMode: {
			enabled: true,
			sticky: false,
			// momentum: false,
		},
		breakpoints: {
			[media_md]: {
				freeMode: false,
			},
		},
	});


	// ===============






	// COMPANIES SLIDER
	const swiperCompanies = new Swiper('.js_swiper_companies', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		resistanceRatio: 0,
		loop: true,
	});
	// ===============

	// FEEDBACK SLIDER
	const swiperMfeedback = new Swiper('.js_swiper_mfeedback', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		resistanceRatio: 0,
		navigation: {
			prevEl: '.slider__arrow_prev',
			nextEl: '.slider__arrow_next',
		},
		on: {
			init: function () {

				setTimeout(() => {
					// feedback slider texts
					document.querySelectorAll('.mfeedback__item').forEach(item => {
						const holderHeigth = item.querySelector('.mfeedback__item-text-wrapper').scrollHeight;
						const textHeigth = item.querySelector('.mfeedback__item-text').scrollHeight;
						if (holderHeigth + 2 >= textHeigth) {
							item.classList.add('textfits');
						}
					});
					// 	
				}, 1000);

			},
		},
	});
	// ===============


	// TAGS

	const swiperTags = new Swiper('.js_swiper_tags', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		resistanceRatio: 0,
		centerInsufficientSlides: true,
		mousewheel: {
			releaseOnEdges: true,
		},
		freeMode: {
			enabled: true,
			sticky: false,
		},
	});
	const swiperTags2 = new Swiper('.js_swiper_tags2', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		resistanceRatio: 0,
		centerInsufficientSlides: false,
		mousewheel: {
			releaseOnEdges: true,
		},
		freeMode: {
			enabled: true,
			sticky: false,
		},
	});


	// CATALOG SLIDER
	const swiperCat = new Swiper('.js_swiper_cat', {
		slidesPerView: 'auto',
		loop: true,
		spaceBetween: 0,
		resistanceRatio: 0,
		speed: 700,
		autoplay: {
			delay: 4200,
		},
	});
	// ===============


	// PRODCARDS SLIDER
	const swiperProdard = new Swiper('.js_swiper_prodcard', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		resistanceRatio: 0,
		navigation: {
			prevEl: '.slider__arrow_prev',
			nextEl: '.slider__arrow_next',
		},
		breakpoints: {
			[media_xxxl]: {
				slidesPerView: 5,
			},
		},
	});







	// PRODUCT SLIDER
	// PICTURES WITH THUMBS
	document.querySelectorAll('.js_productphotos').forEach(hasthumbs => {

		const swiperProductThumbs = new Swiper(hasthumbs.querySelector('.js_swiper_prodthumbslider'), {
			slidesPerView: 'auto',
			spaceBetween: 0,
			resistanceRatio: 0,
			direction: 'vertical',
			// centeredSlides: true,
			// centeredSlidesBounds: true,
			// breakpoints: {
			// 	[media_md]: {
			// 		slidesPerView: 6,
			// 	},
			// 	[media_lg]: {
			// 		slidesPerView: 3,
			// 	},
			// 	[media_xl]: {
			// 		slidesPerView: 4,
			// 	},
			// 	[media_xxl]: {
			// 		slidesPerView: 3,
			// 	},
			// },
		});


		const swiperProduct = new Swiper(hasthumbs.querySelector('.js_swiper_prodslider'), {
			// slidesPerView: 'auto',
			// spaceBetween: 24,
			resistanceRatio: 0,
			lazyPreloadPrevNext: 2,
			speed: 550,
			// autoHeight: true,

			thumbs: {
				swiper: swiperProductThumbs,
			},
			on: {
				// pause on slide change
				slideChange: function (swiper) {
					swiper.hostEl.querySelectorAll('video').forEach(sliderVideo => {
						if (!sliderVideo.paused) {
							sliderVideo.pause();
						}
					});
				},
			},
		});

		// swipe on video slide
		document.querySelectorAll('.js_swiper_prodslider video').forEach(sliderVideo => {
			let touchstartX = 0;
			let touchendX = 0;
			let clickstartX = 0;
			let clickX = 0;


			// sliderVideo.addEventListener('touchstart', (e) => {
			// 	touchstartX = e.changedTouches[0].screenX;
			// }, { passive: supportsPassive ? true : false });
			// sliderVideo.addEventListener('touchend', (e) => {
			// 	touchendX = e.changedTouches[0].screenX;
			// 	if (touchendX > touchstartX) {
			// 		swiperHero.slidePrev();
			// 	}
			// 	if (touchendX < touchstartX) {
			// 		swiperHero.slideNext();
			// 	}
			// });


			let isActive = false;
			sliderVideo.addEventListener('mousedown', (e) => {
				isActive = true;
				clickstartX = e.pageX;
			});
			sliderVideo.addEventListener('mousemove', (e) => {

				if (isActive) {
					clickX = e.pageX;
					if (clickX - clickstartX < -150) {
						swiperProduct.slideNext();
						isActive = false;
					}
					if (clickX - clickstartX > 150) {
						swiperProduct.slidePrev();
						isActive = false;
					}
				}
			});
			sliderVideo.addEventListener('mouseup', (e) => {
				isActive = false;
			});

		});


	});



	const swiperTextblock = new Swiper('.js_swiper_textblock', {
		slidesPerView: 1,
		spaceBetween: 0,
		resistanceRatio: 0,
		speed: 600,
		navigation: {
			prevEl: '.textblock-slider__arrow_prev',
			nextEl: '.textblock-slider__arrow_next',
		},
	});






});